<template>
  <div class="container">
    <div class="row mt-5">
    <h1>{{ $t('welcomeHomeGuestPage') }}</h1>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IndexGuestTitlePage',
  }
</script>

<style>

</style>
  